<template lang="pug">
.check-in-container-box(
  v-if="days.length"
  :class="{ 'disabled': !showSignInCard }"
)
  .svip-banner(v-if="!currentlyIsVip && !newStyle" @click="goVipPage")
    .icon
    .vip-title 超级会员
    .vertical-line
    .vip-desc 签到领
    .vip-desc(style="color: #F54311; font-weight: 600;") 3倍奖励金
    .vip-desc ，享兑丰富好礼
    .right-icon
  .check-in-container(:class="newStyle? 'new-style' : ''")
    .title
      .main(v-html="titleStyle(title)")
      .sub(@click="goAppAndCheckin", v-if="false")
        span 去APP签到赚双倍
        .common-arrow-right
      .vip-buoy(v-if="currentlyIsVip && !newStyle")
        .vip-buoy-icon
        .vip-buoy-text 超级会员享3倍
    .body(v-show="show")
      template(v-if="preparing")
        .shadow-process
      template(v-else)
        .days
          .cross-line(v-if="!newStyle")
          .day-item(v-for="(item,index) in days", :class="item.class")
            .icon(:class="{'border': newStyle && item.checked}")
              img(:src="item.checkIcon")
              span.amount(v-if="!newStyle || (newStyle && !item.checked)") {{ item.amount }}
            .text.double(v-if="item.checked && item.vip") 已翻倍
            .text(v-else) {{ checkinText(item,index) }}
    .vip-tip(@click="goVipPage" v-if="!currentlyIsVip && newStyle")
      .bold 超级会员特权：
      .grey 签到得
      .red 3倍奖励金
      .grey ，享兑丰富好礼
      .common-arrow-right
  checkin-modal(
    :show.sync="modal",
    :days="days",
    :title="title",
    :active-index="activeIndex",
    :coupon="coupon",
    :currentlyIsVip="currentlyIsVip"
    :bonusTotal="bounty"
    :repeatSignDesc="repeatSignDesc"
    :bountyCountToday="today"
    :didSignToday="didSignToday"
    v-on="$listeners"
    @taskOpen="taskOpen"
    :canOpenTask="canOpenTask"
  )
  do-task-money(
    :show.sync="taskShow"
    :taskInfo="taskPopupInfo"
    @btnClick="handleTaskPopupBtnClick"
  )
  special-checkin-modal(
    :show.sync="special",
    :coins="coins",
    @close="$emit('bounty')",
    :active-index="activeIndex"
  )
  img(v-show="false" src="https://m.hellobike.com/resource/gallery/350/AJRHNzYWDG.png?x-oss-process=image/quality,q_80")
</template>

<script>
import {
  getDiversion,
  getHelloCommand,
  getSignAndRecommend,
} from '@/api/fuli';
import { env, Native } from '@hb/NBridge/lib/h5';
import { UBT } from '@hb/tianqi/lib/ubt.h5';
import eventBus from '@/const/eventBus.js';
import { jumpUrl } from '@/utils/tools';
import config from '@/const/config';
import SPM from '../common/spm';
import { getTaskPopupData } from '../common/task';
import { getTokenAndKey, getCityInfo } from '../../../utils';
import { ParamsUtil } from '../../../utils/params';
import CheckinModal from './checkin-modal';
import DoTaskMoney from './dotask-money';
import SpecialCheckinModal from './special-checkin-modal';
import { POPUP_WINDOW_KEY, RAKE_BACK_AB } from '../consts';

const ACTIVE_ICON = 'https://m.hellobike.com/resource/AppPlatformH5/fuli/lX02rwjiuTTXbTgdXMbco.png';
const CHECKIN_ACTIVE_ICON = 'https://m.hellobike.com/resource/AppPlatformH5/fuli/cPdfYpajOmEqMttQ46R5a.png';
const INACTIVE_ICON = 'https://m.hellobike.com/resource/gallery/833/8TcECPUAyI.png';
const CHECKIN_INACTIVE_ICON = 'https://m.hellobike.com/resource/AppPlatformH5/fuli/sPLJzvaGM5RFPOfzLNTap.png';
const RED_ICON = 'https://m.hellobike.com/resource/helloyun/15979/daAZSqJK3-.png';
const NEW_CHECKIN_ACTIVE_ICON = 'https://m.hellobike.com/resource/gallery/43/fmkQ87XZ0G.png';

const mapper = (v, newStyle) => {
  const {
    title, bonusList, bountyCountToday, doSignThisTime, bountyGood, currentlyIsVip, repeatSignDesc,
    didSignToday, moduleInfo,
  } = v;
  return {
    title,
    today: bountyCountToday,
    doSignThisTime,
    days: (bonusList || []).map((item, index) => {
      const { icon, checkIcon } = (() => {
        if (!newStyle) {
          if (!item.didSign) {
            if (item.multipleDesc) {
              return {
                icon: RED_ICON,
                checkIcon: RED_ICON,
              };
            }
            return {
              icon: INACTIVE_ICON,
              checkIcon: CHECKIN_INACTIVE_ICON,
            };
          }
          return {
            icon: ACTIVE_ICON,
            checkIcon: CHECKIN_ACTIVE_ICON,
          };
        }
        if (!item.didSign) {
          if (item.multipleDesc) {
            return {
              icon: RED_ICON,
              checkIcon: RED_ICON,
            };
          }
          return {
            icon: INACTIVE_ICON,
            checkIcon: INACTIVE_ICON,
          };
        }
        return {
          icon: ACTIVE_ICON,
          checkIcon: NEW_CHECKIN_ACTIVE_ICON,
        };
      })();

      return {
        text: `第${index + 1}天`,
        checked: item.didSign,
        amount: item.bonusCount,
        icon,
        checkIcon,
        class: (item.multipleDesc && !item.didSign) ? ['red'] : [],
        vip: item.isVip,
      };
    }),
    coupon: bountyGood,
    currentlyIsVip,
    repeatSignDesc,
    didSignToday,
    moduleInfo,
  };
};

export default {
  components: {
    CheckinModal,
    SpecialCheckinModal,
    DoTaskMoney,
  },
  props: {
    bounty: {
      type: Number,
      default: 0,
    },
    popupKey: {
      type: String,
      default: POPUP_WINDOW_KEY.checkin_window,
    },
  },
  data() {
    return {
      preparing: true,
      days: [],
      show: true,
      title: '签到赚奖励金',
      today: '0',
      modal: false,
      // 任务弹窗是否展示
      taskShow: false,
      doSignThisTime: false,
      diversion: null,
      // 哈口令
      command: null,
      env,
      // 特殊签到弹窗
      special: false,
      coupon: null,
      currentlyIsVip: false,
      repeatSignDesc: null,
      taskList: [],
      // 是否能打开任务弹窗
      canOpenTask: false,
      didSignToday: false,
      firstLoad: true,
      // 任务弹窗信息
      taskPopupInfo: {},
      // 激励视频是否第一次加载完成
      firstLoaded: false,
    };
  },
  inject: ['newTaskScene', 'rakeSceneAb'],
  computed: {
    newStyle() {
      return this.newTaskScene();
    },
    activeIndex() {
      const index = [...(this.days || [])].reverse().findIndex((v) => v.checked);
      if (index !== -1) {
        return (this.days || []).length - index - 1;
      }
      // 未获取到表示当前没有签到信息，值设置为-1
      return -1;
    },
    coins() {
      const data = [];
      if (this.doSignThisTime) {
        data.push({ amount: this.today, name: '今日签到' });
      }
      if (this.diversion) {
        const { propertyCount, activityName } = this.diversion;
        data.push(
          { amount: propertyCount, name: activityName },
        );
      }
      return data;
    },
    titleStyle() {
      return (title) => {
        if (!title) {
          return '';
        }
        return title.replace(/可得(\d{1,})奖励金/g, (index, val) => {
          const [k1, k2] = index.split(val);
          if (this.newStyle) { return `${k1}<span style='color:red ;margin-left:0.06rem'>${val}${k2}</span>`; }
          return `${k1}<span style='color:red'>${val}</span>${k2}`;
        });
      };
    },
    checkinText() {
      return (item, index) => {
        if (item.checked) {
          return '已签';
        } if (index === 0) {
          return '未签';
        }
        return item.text;
      };
    },
    // 是否展示新版电商返佣
    showSignInCard() {
      const rakeSceneAb = this.rakeSceneAb();
      return rakeSceneAb !== RAKE_BACK_AB.NEW_V2;
    },
  },
  created() {
    // 初始化签到数据
    this.initData();
  },
  mounted() {
    eventBus.$on('showCheckInModal', () => {
      this.canOpenTask = false;
      this.modal = true;
    });
    eventBus.$on('sendTaskPopupData', (taskList) => {
      this.taskList = taskList;
      if (taskList.length > 0) {
        this.canOpenTask = true;
      }
      if (this.taskShow) {
        this.taskOpen({ popupIsShow: true });
      }
    });

    // 签到模块曝光
    SPM.moduleExpose({
      moduleId: 'Welfare_signmodule',
      contentId: 'Welfare_signmodule',
      businessInfo: {},
    });
  },
  methods: {
    // 展示任务弹窗
    taskOpen(options) {
      const { popupIsShow } = options || {};
      const { visible, taskInfo } = getTaskPopupData(this.taskList);

      if (!popupIsShow) {
        this.taskShow = visible;
        this.canOpenTask = !!taskInfo;
      }
      if (taskInfo) {
        this.taskPopupInfo = taskInfo;
      }
    },
    goAppAndCheckin() {
      UBT.clickButton({
        pageId: 'Welfare',
        buttonName: 'sign_more',
        categoryId: 'platform',
        businessInfo: {},
      });
      if (env.isAliMP || env.isAliMPMonitor) {
        if (this.command) {
          Native.callNative({
            method: 'clipBoard',
            params: this.command,
          });
        }
        Native.callNative({
          method: 'goOperationUrlV2',
          params: 'https://m.hellobike.com/ebike-h5/latest/index-3.html#/activity/common?guid=ce8d4dc4760945588d3c8411d3f6ba70&beyondMP=true',
        });
        return;
      }
      window.location.href = 'https://m.hellobike.com/ebike-h5/latest/index-3.html#/activity/common?guid=ce8d4dc4760945588d3c8411d3f6ba70&beyondMP=true';
    },
    async initData() {
      const [
        { token }, { cityCode, adCode },
      ] = await Promise.all([getTokenAndKey(), getCityInfo()]);
      const [diversion, info, command] = await Promise.all([
        getDiversion({
          token, cityCode, adCode,
        }).then((v) => v.data).catch(() => null),
        getSignAndRecommend({ token }).then((v) => v.data).catch(() => null).then((v) => { this.$emit('bounty'); return v; }),
        getHelloCommand({ commandType: '1' }).then((v) => v.data || {}).catch(() => ({})),
      ]);
      if (info) {
        // 签到数据发送出去
        eventBus.$emit('signInDataSent', info);

        if (info.moduleInfo && !this.firstLoaded) {
          // 数据发送给红包模块
          eventBus.$emit('videoRedPacketDataSent', info.moduleInfo);
          this.firstLoaded = true;
        }
        this.preparing = false;
        Object.assign(this, mapper(info, this.newStyle));
      } else {
        this.show = false;
      }
      if (command) {
        this.command = command;
      }

      if (diversion) {
        this.special = true;
        this.diversion = diversion;
        UBT.moduleExpose({
          pageId: 'Welfare',
          categoryId: 'platform',
          moduleId: 'sign_Popup',
          contentId: 'sign_Popup',
          exposureTimes: 1,
          businessInfo: {
            day: `${this.activeIndex + 1}`,
            pop_state: this.coins && this.coins.length === 1 ? '1' : '2',
            adsource: ParamsUtil.getParam('adsource'),
          },
        });
      } else if (this.doSignThisTime && this.popupKey === POPUP_WINDOW_KEY.checkin_window) {
        this.$nextTick(() => {
          this.modal = true;
        });
        UBT.moduleExpose({
          pageId: 'Welfare',
          categoryId: 'platform',
          moduleId: 'sign_Popup',
          contentId: 'sign_Popup',
          exposureTimes: 1,
          businessInfo: {
            day: `${this.activeIndex + 1}`,
            pop_state: '0',
            adsource: ParamsUtil.getParam('adsource'),
          },
        });
      } else if (this.repeatSignDesc && this.firstLoad) {
        this.firstLoad = false;
      }
    },
    async goVipPage() {
      SPM.clickButton({
        buttonName: 'Welfare_sign_member',
        businessInfo: {},
      });
      jumpUrl(
        `https://m.hellobike.com/AppPlatformH5/${
          config.env !== 'pro' ? `${config.env}/` : ''
        }latest/index.html#/vip/v2/transfer?adsource=fulizhongxin`,
      );
    },
    // 任务弹窗按钮点击
    async handleTaskPopupBtnClick({ closePopup, info }) {
      this.taskShow = !closePopup;
      if (info) {
        this.taskPopupInfo = info;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.check-in-container-box {
  overflow: hidden;

  &.disabled {
    height: 0;
    margin-bottom: 0 !important;
  }

  .svip-banner {
    padding-bottom: 0.15rem;
    margin-bottom: -0.15rem;
    width: 100%;
    height: 0.52rem;
    display: flex;
    align-items: center;
    background: url(https://m.hellobike.com/resource/helloyun/18536/1H91q_Group%2089.png) no-repeat top/100% 100%;

    .icon {
      margin-left: 0.16rem;
      width: 0.2rem;
      height: 0.2rem;
      background: url(https://m.hellobike.com/resource/helloyun/18536/sF9CJkFp4U.png) no-repeat top/100% 100%;
    }

    .vip-title {
      margin-left: 0.05rem;
      color: #3c1401;
      font-family: PingFang SC, sans-serif;
      font-size: 0.13rem;
      font-weight: 600;
    }

    .vertical-line {
      margin: 0 0.045rem;
      width: 0.01rem;
      height: 0.1rem;
      background-color: #3b1401;
      opacity: 0.5;
    }

    .vip-desc {
      color: #3b1401;
      font-family: PingFang SC, sans-serif;
      font-size: 0.12rem;
      font-weight: 400;
    }

    .right-icon {
      margin-left: 0.07rem;
      width: 0.045rem;
      height: 0.08rem;
      background: url(https://m.hellobike.com/resource/helloyun/18536/rNC6yDEEin.png) no-repeat top/100% 100%;
    }
  }

  .check-in-container {
    position: relative;
    z-index: 8;
    border-radius: 0.12rem;
    padding: 0.12rem 0.16rem 0.1rem;
    max-height: 1.05rem;
    overflow: hidden;
    background-color: #fff;

    .vip-tip {
      width: 3.35rem;
      height: 0.27rem;
      background: #f2f6fa;
      color: #946109;
      font-family: "PingFang SC", sans-serif;
      font-size: 0.12rem;
      display: flex;
      align-items: center;
      border-radius: 0.08rem;
      margin-top: 0.12rem;
      padding-left: 0.08rem;

      .bold {
        color: #242729;
        font-weight: 700;
      }

      .grey {
        color: #6c747a;
      }

      .red {
        color: #f54311;
      }

      .common-arrow-right {
        margin-left: -0.04rem;
        border-color: #5a6066;
      }
    }

    .title {
      position: relative;
      display: flex;
      // justify-content: space-between;
      margin-bottom: 0.1rem;

      .main {
        font-size: 0.14rem;
        color: #242729;
      }

      .sub {
        font-size: 0.12rem;
        color: #ff5526;
        display: flex;
        align-items: center;

        .common-arrow-right {
          border-color: #ff5526 !important;
        }
      }

      .vip-buoy {
        margin-left: 0.05rem;
        width: 1.06rem;
        height: 0.18rem;
        display: flex;
        justify-content: center;
        align-items: center;
        background: url(https://m.hellobike.com/resource/helloyun/18536/cVzhU_Rectangle%2033.png) no-repeat top/100%;

        &-icon {
          margin-top: -0.02rem;
          width: 0.12rem;
          height: 0.11rem;
          background: url(https://m.hellobike.com/resource/helloyun/18536/zsNXGCkfrI.png) no-repeat top/100%;
        }

        &-text {
          margin-left: 0.026rem;
          color: #783a0d;
          font-family: PingFang SC, sans-serif;
          font-size: 0.12rem;
          font-weight: 500;
        }
      }
    }

    .body {
      width: 100%;
      overflow: hidden;

      .shadow-process {
        width: 2.32rem;
        height: 0.36rem;
        background: #f7f9fa;
        border-radius: 0.04rem;
      }

      .days {
        width: 200%;
        display: flex;
        transform: scale(0.5);
        transform-origin: 0 0;
        position: relative;
        justify-content: space-between;

        .cross-line {
          width: 5.84rem;
          height: 0.02rem;
          left: 0.22rem;
          position: absolute;
          top: 0.31rem;
          background-color: #f5e1b4;
        }
      }

      .day-item {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        z-index: 2;

        .icon {
          width: 0.62rem;
          height: 0.62rem;
          position: relative;
          margin-bottom: 0.16rem;

          img {
            width: 100%;
            height: 100%;
          }

          .amount {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            font-size: 0.19rem;
            line-height: 1;
            color: #fff;
            text-shadow: 0 0 0 #a29bb0;
          }
        }

        .text {
          font-size: 0.18rem;
          color: #879099;
          white-space: nowrap;
        }

        .double {
          color: #ff5526;
        }

        &.red {
          .icon {
            margin-top: 0.02rem;
            width: 0.5rem;
            height: 0.6rem;
          }

          .amount {
            display: none;
          }
        }
      }
    }

    &.new-style {
      padding: 0.12rem 0.08rem;
      max-height: 1.61rem;
      background: linear-gradient(171.65deg, #ecefff 4.82%, #fff 21.93%);

      .title {
        padding: 0 0.025rem;
      }

      .body {
        max-height: 0.73rem;
        padding: 0 0.025rem;

        .days {
          .day-item {
            .icon {
              width: 0.86rem;
              height: 1.08rem;
              border-radius: 0.16rem;
              background-color: #fff4e0;
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;

              &.border {
                border: 0.01rem solid #ffc157;
              }

              img {
                width: 0.46rem;
                height: 0.48rem;
              }

              .amount {
                font-family: DIN Alternate, sans-serif;
                font-weight: 700;
                font-size: 0.24rem;
                color: #92681f;
                margin-top: 0.05rem;
                position: static;
                top: auto; /* 恢复默认 */
                left: auto; /* 恢复默认 */
                transform: none; /* 取消变换 */
              }
            }
          }
        }
      }
    }
  }
}
</style>
